import fetchRequest from "./fetchRequest";
import { goalTrackerApiBaseUrl, goalTrackerApiKey } from "../settings/appSettings";

export function parseErrorStatus(error, errorType = "system") {
    const isError = (err) => err instanceof Error;
    const isString = (val) => typeof val === "string";
    const errorMessage = isError(error) && error.message || isString(error) && error || "";
    const isRequestError = /Status 4\d\d/i.test(errorMessage);
    const isSystemError = /Status 5\d\d/i.test(errorMessage);

    if (errorType === "request") {
        return isRequestError;
    } else {
        return isSystemError;
    }
}

export function parseResponse(response) {
    if (response.ok) {
        return response.json();
    }

    return response.text()
        .then((text) => {
            return Promise.reject(Error(`Status ${response.status} ${response.statusText}: ${text||""}`));
        })
        .catch(() => {
            return Promise.reject(new Error(`Status ${response.status} ${response.statusText}: Failed to request goal tracker data.`));
        });

}

export function validateTrackerData(respData, goalRef) {
    const requiredFields = ["goalRef", "currentGoalState", "goalTarget"];

    const missingRequiredFields = requiredFields.filter(field => typeof field === "undefined");

    if (missingRequiredFields.length) {
        throw new Error(`Missing the required data from json ${missingRequiredFields.join(",")}`);
    }

    if (respData.goalRef !== goalRef) {
        throw new Error(`Unexpected mismatch goalRef. Expected to receive goalRef ${goalRef}, but received ${respData.goalRef}`);
    }

    return true;
}

export function transformDataResp(data) {
    const transformedData = {
        ...data,
        currentGoalStateLabel: data?.currentGoalStateLabel?.replace(/(\.\d+)/g, "") || "",
        goalTargetLabel: data?.goalTargetLabel?.replace(/(\.\d+)/g, "") || ""
    };

    return transformedData;
}

export async function getGoalTrackerData(goalTrackerRef) {
    const requestUrl = `${goalTrackerApiBaseUrl}/goals/${goalTrackerRef}`;
    const timeout = 10 * 1000; // 10 Seconds

    try {
        const resp = await fetchRequest(requestUrl, {timeout, headers: {
            "Content-type": "application/json",
            "Ocp-Apim-Subscription-Key": goalTrackerApiKey
        }});

        const respJson = await parseResponse(resp);

        // Validate Data
        validateTrackerData(respJson, goalTrackerRef);
        const respData = transformDataResp(respJson);

        return respData;
    } catch (err) {
        return Promise.reject(err);
    }
}

export async function getWebSocketEndpoint() {
    const requestUrl = `${goalTrackerApiBaseUrl}/ws/connection`;
    const timeout = 10 * 1000; // 10 Seconds

    try {
        const resp = await fetchRequest(requestUrl, {
            timeout,
            headers: {
                "Content-Type": "application/json",
                "Ocp-Apim-Subscription-Key": goalTrackerApiKey
            }
        });
        const respJson = await parseResponse(resp);
        const { url } = respJson;
    
        return url;
    } catch (err) {
        return null;
    }
}

let currentGoalState = 100;

export async function getGoalTrackerDataMock(goalTrackerRef) {
    const mockData = {
        "goalRef": `${goalTrackerRef}`,
        "goalName":"Name of Stub Goal",
        "currentGoalState": currentGoalState,
        "goalTarget":100,
        "targetType":"Sponsorships",
        "currentGoalStateLabel": `${currentGoalState} sponsorships`,
        "goalTargetLabel": "raised of 100 goal",
        "goalActive":true,
        "displayType": "bubble"
    };

    return Promise.resolve(mockData);
}